import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import CustomCheckbox from './CustomCheckbox';
import clsx from 'clsx';

interface CheckboxRowProps {
  title: React.ReactNode;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  classes: {
    container?: string;
    setPointContainer?: string;
    activeOption?: string;
    selectModeStyle?: string;
    [key: string]: string | undefined;
  };
  children?: React.ReactNode;
}

const CheckboxRow: React.FC<CheckboxRowProps> = ({ title, checked, onChange, classes, children }) => {
  return (
    <Grid
      container
      className={clsx(classes.container, classes.setPointContainer, {
        [classes.activeOption || '']: checked,
      })}
    >
      <div
        className={classes.checkboxRowContainer}
      >
        <CustomCheckbox onChange={onChange} checked={checked} />
        <Typography className={classes.selectModeStyle}>{title}</Typography>
      </div>
      {children}
    </Grid>
  );
};

export default CheckboxRow;
